import React, { useEffect, useMemo, useState } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import { FormattedMessage, useIntl } from "react-intl";
import useOpenWindow from "../../../../../../hooks/open-window";
import ChangeEmail from "./change-email";
import { useDispatch, useSelector } from "react-redux";
import { BigButton } from "../../../../../../components/button";
import Alert from "../../../../../../components/alert";
import { fetchRegister2 } from "../../../../../../../api";
import moment from 'moment'
import { action_fetch_customer } from "../../../../../../../store/actions/pages/customer";


const ConfirmCoupon = props => {
    const { coupon } = props;

    const couponName = useMemo(() => {
        if (coupon?.couponName) {
            return coupon.couponName.indexOf('R$') != -1 && coupon.couponName.indexOf('.') != -1 ? String(coupon.couponName || '').replace(".", ",") : coupon.couponName;
        }
    }, [coupon]);

    return <div className={cls.ConfirmCoupon}>
        <div className={cls.LeftCoupon}>
            <div className={cls.CouponName}>
                {couponName}
            </div>

            {
                coupon?.beginDate && coupon?.endDate && <div className={cls.CouponTime}>
                    <span>{moment(coupon.beginDate).format('DD/MM/YYYY HH:mm')}~{moment(coupon.endDate).format('DD/MM/YYYY HH:mm')}</span>
                </div>
            }
        </div>

        <div className={cls.CouponCheck}>
            <a href="/user/coupons"><FormattedMessage id="check" defaultMessage="Check" /> {'>'}</a>
        </div>
    </div>
}

const NewCustomerBlocker = props => {
    const { thanks, message, tips, email, coupon } = props
    const [finished, setFinished] = useState(false)
    const [loading, setLoading] = useState(false)
    const [password, setPassword] = useState(null);
    const Intl = useIntl();
    const global = useSelector(state => state.global);
    const { config } = global;

    const dispatch = useDispatch();

    const handlePassword = async () => {
        if (!password) {
            Alert(Intl.formatMessage({ id: 'please_input_password_first', defaultMessage: "Please input password first" }))
            return;
        }
        setLoading(true);
        fetchRegister2({
            email,
            password
        }).then((response) => {
            if (response.code === 200) {
                setFinished(true);
                dispatch(action_fetch_customer());
            } else {
                Alert(response.result || response);
            }
        }).finally(() => {
            setLoading(false);
        });

        if (window.GeekoSensors) {
            window.GeekoSensors.Track('ELClick', {
                clicks: 'password_save'
            })
        }
    }

    return <div className={cls.NewCustomerBlocker}>
        {
            !finished ? <React.Fragment>
                {
                    tips && <div className={cls.WarnTip}>
                        <span dangerouslySetInnerHTML={{ __html: tips }}></span>
                    </div>
                }

                <div className={cls.Bd}>
                    <div>
                        <Iconfont className={cls.Icon}>&#xe6b7;</Iconfont>
                    </div>

                    <div className={cls.Title}>
                        <span dangerouslySetInnerHTML={{ __html: thanks }} />
                    </div>

                    <div className={cls.Message}>
                        <span dangerouslySetInnerHTML={{ __html: message }} />
                    </div>

                    <div className={cls.EmailInput}>{email}</div>

                    <div className={cls.PassWordinput}>
                        <input
                            type="text"
                            onFocus={() => {
                                if (window.GeekoSensors) {
                                    window.GeekoSensors.Track('ELClick', {
                                        clicks: 'password'
                                    })
                                }
                            }}
                            placeholder={Intl.formatMessage({ id: 'set_password', defaultMessage: "Set password" })}
                            value={password}
                            onChange={(e) => { setPassword(e.target.value) }}
                        />
                    </div>

                    <div className={cls.Message2}>
                        <FormattedMessage id="register_and_get" defaultMessage="Register on {siteName} to track your order and get more discount!" values={{ siteName: config?.name }} />
                    </div>

                    <div className={cls.SubmitContainer}>
                        <BigButton loading={loading} onClick={handlePassword}><FormattedMessage id="save" defaultMessage="Save" /></BigButton>
                    </div>
                </div>
            </React.Fragment> : <React.Fragment>
                <div className={cls.Bd}>
                    <div>
                        <Iconfont className={cls.Icon}>&#xe6b7;</Iconfont>
                    </div>

                    <div className={cls.Title}>
                        <FormattedMessage id="welcome_to" defaultMessage="Welcome to" /> {config?.name}
                    </div>

                    <div className={cls.Message}>
                        <FormattedMessage id="check_order_msg" defaultMessage="Now, you can check your order in your account. Please check “My order” under “Me” to track your order." />
                    </div>

                    {
                        coupon && <div className={cls.CouponContainer}>
                            <ConfirmCoupon coupon={coupon} />
                        </div>
                    }
                </div>
            </React.Fragment>
        }
    </div>
}

const ChangeCustomerMessage = props => {
    useStyles(cls);
    const { customer, transaction, isNew, transactionMessages, isLogin } = props;
    const { m1073 } = transactionMessages;
    const { shippingDetail, coupon, warnMsg, message } = transaction;
    const { show, setShow } = useOpenWindow("confirm-change-email");
    const intl = useIntl()

    const isCashout = useMemo(() => {
        const { payMethod } = transaction;
        return ['20', '21', '16', '23', '25', '29', '27', '28', '30', '31', '34', '35', '37', '40', '41', '43', '44', '129', '130'].indexOf(payMethod) >= 0
    }, [transaction]);

    const shouldShowTip = useMemo(() => {
        const email = customer?.communicationEmail
        let emailEnd = email?.split('@')?.[1] || ''
        if (
            emailEnd?.toLocaleLowerCase()?.indexOf('chic-fusion') != -1 ||
            emailEnd?.toLocaleLowerCase()?.indexOf('ivrose') != -1 ||
            emailEnd?.toLocaleLowerCase()?.indexOf('bellewholesale') != -1 ||
            emailEnd?.toLocaleLowerCase()?.indexOf('boutiquefeel') != -1
        ) {
            // 说明是系统自动生成的邮箱
            return true
        }
        return false
    }, [customer])

    const getTitle = () => {

        if (isCashout) {
            if (transaction.payMethod === '16' || transaction.payMethod === '23' || transaction.payMethod === '25' || transaction.payMethod === '29') { return <div>Seu pedido de compra foi realizado! Pague agora seu Boleto Bancário paraagilizar a confirmação do seu pedido.</div> }
            return null
        }


        return <div>
            <span dangerouslySetInnerHTML={{ __html: transaction.message }} />

            {
                isLogin && <React.Fragment>
                    <a style={{ color: 'skyblue' }} onClick={(evt) => {
                        evt.preventDefault();
                        setShow(true);
                    }}>
                        {customer?.communicationEmail}
                        <Iconfont style={{ marginLeft: 10, color: 'skyblue', cursor: 'pointer' }}>&#xe61f;</Iconfont>
                    </a>
                    {
                        shouldShowTip &&
                        <div className={cls.changeEmailTip}>
                            {intl.formatMessage({id: 'systemEmailNotice', defaultMessage:'Notice: Please update your email to receive important notifications from us. Click to update now.'})}
                        </div>
                    }
                </React.Fragment>
            }

            {
                !isLogin && !isNew && <span style={{ color: 'skyblue' }}>{customer?.communicationEmail || shippingDetail?.email}</span>
            }

            {/* {
                {this.state.isNew && <div style={{ marginTop: 15 }}><Btn onClick={this.handleSetPassword.bind(this)}><FormattedMessage id="set_password" /></Btn></div>}
                isNew && <div style={{ marginTop: 15 }}><a><FormattedMessage id="set_password" /></a></div>
            } */}
        </div>
    }

    return <div className={cls.ChangeCustomerMessage}>
        {
            isNew ? <NewCustomerBlocker coupon={coupon} email={shippingDetail?.email} thanks={m1073?.message} tips={warnMsg} message={message} /> : <div className={cls.CustomerBlocker}>
                <div className={cls.Hd}>
                    <Iconfont className={cls.Icon}>&#xe73c;</Iconfont>
                    <span className={cls.Title} dangerouslySetInnerHTML={{ __html: m1073?.message }}></span>
                </div>

                <div className={cls.Bd}>{getTitle()}</div>
            </div>
        }

        <ChangeEmail
            show={show}
            onClose={() => setShow(false)}
            customer={customer}
            transaction={transaction}
        />
    </div>
}

export default ChangeCustomerMessage;